export default __webpack_public_path__ + "static/media/Torment.ae25313d.jpg";